import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService, type PatSnapCommonResponseData, type PatSnapSuccessResponseData } from '@patsnap/tahiti-core/common/ps-http';
import type {
    ProjectShareApi,
    SharedUserListParams,
    SharedUserListResponse,
    RemoveSharedUserParams,
} from '../project-share-api';
import type { InviteProjectByEmailData } from '@/domain/types';

@injectable()
export class ProjectShareApiImpl extends PsHttpService implements ProjectShareApi {
    get options() {
        return {
            // @ts-ignore
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/work/project`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    shareByEmail(params: InviteProjectByEmailData): Promise<void> {
        return this.post<PatSnapSuccessResponseData<void>>({
            url: '/share/email',
            data: params,
        }).then((res) => {
            return res.data;
        });
    }

    getSharedUserList(data: SharedUserListParams): Promise<SharedUserListResponse> {
        return this.post<PatSnapCommonResponseData<SharedUserListResponse>>({
            url: '/share/user/list',
            data,
        }).then((res) => {
            return res.data as SharedUserListResponse;
        });
    }

    removeSharedUser(params: RemoveSharedUserParams): Promise<void> {
        return this.delete<PatSnapSuccessResponseData<void>>({
            url: '/share/delete',
            data: params,
        }).then((res) => {
            return res.data;
        });
    }
}
